
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ejercicios",
      function () {
        return require("private-next-pages/ejercicios/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ejercicios"])
      });
    }
  